
import Ads from "../Components/FirstComponents/Ads";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import YouTubeVideoPlayer from "../Utils/YouTubeVideoPlayer";
import Banner from "../Utils/Banner";

function BlogDetails() {
  // get route params id
  const { id } = useParams();
  const [content, setContent] = useState({});

  // fetch data from api using id

  // if (!content || !content.description) {
  //   return null; // Or any other fallback behavior
  // }
  // const plainText = content.description.replace(/<[^>]*>?/gm, '');

  // Truncate the text to 300 words
  // const truncatedText = plainText.split(' ').slice(0, 5).join(' ');

  useEffect(() => {
    const callContent = async () => {
      try {
        const res = await fetch(
          process.env.REACT_APP_BASE_API_URL + "/contents/" + id,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            // credentials: "include",
          }
        );

        const data = await res.json();
        console.log(data);
        setContent(data);
        console.log(content);

        if (!res.status === 200) {
          const error = new Error(res.error);
          throw error;
        }
      } catch (err) {
        console.log(err);
      }
    };
    callContent();
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <>
      <div
        className="bg-gray-200 bg-no-repeat bg-contain "
        style={{
          backgroundImage: "url('/assets/background.png')",
          backgroundPosition: "right top",
        }}
      >
        <div className="mx-auto mt-32 max-w-7xl">
          {/* <Hero /> */}
          <h3 className="text-[#2d95a5] bg-white bg-opacity-80 font-bold text-xl md:text-2xl px-4 sm:px-6 lg:px-8 py-4">
            Details of {content.title}
          </h3>
          <div className="px-4 sm:px-6 lg:px-8">
            <section className="rounded-lg mt-4 bg-white bg-opacity-80 font-ubuntu mb-5 p-4 sm:p-6">
              <div className="flex flex-col gap-4">
                <div className="flex flex-col justify-center w-full">
                  {/* <h1 className='text-[#2d95a5] font-semibold text-lg lg:text-xl xl:text-xl mb-2'>
                    {content.title}
                  </h1> */}

                  <div className=" rounded-tl-lg rounded-tr-lg rounded-bl-none rounded-br-none mt-4 p-4 space-y-2">
                    <p className="text-xs xl:text-sm">
                      {/* <div
                        className='w-full p-4 prose rounded-md'
                        dangerouslySetInnerHTML={{
                          __html: content.description,
                        }}
                      /> */}
                      <div>
                        
                        <div>
                          {/* {content.file_path && (
                            <div className="w-full">
                              <video
                                className="w-full mt-4 rounded-md shadow-md"
                                controls={true}
                                autoPlay={false}
                                crossOrigin="anonymous"
                              >
                                <source
                                  crossOrigin="anonymous"
                                  src={content.file_path}
                                />
                              </video>
                            </div>
                          )}  */}

                        </div>
                        <div className="w-full flex items-center justify-center my-4">
                          {content.video_url && (
                            <YouTubeVideoPlayer videoLink={content.video_url} />
                          )}
                        </div>
                         
                        <div className="w-full flex items-center justify-center my-4">
                          {content.thumbnail && !content.video_url && (
                            <div className="flex items-center justify-center w-full">
                              <img
                                src={content.thumbnail}
                                alt="Thumbnail"
                                className="w-full max-w-full h-auto object-contain rounded-md shadow-md"
                              />
                            </div>
                          )}
                        </div>

 
                      </div>
                    </p>
                  </div>
                </div>

                <div className="w-full">
                  {/* <img
                    src={content.thumbnail}
                    crossOrigin='anonymous'
                    alt=''
                    className='object-contain w-full h-full'
                  /> */}

                  {/* {content.description} */}
                  {/* <div className="p-5" dangerouslySetInnerHTML={{ __html: content.description }} /> */}

                  <div className="w-full">
                    <div
                      className="p-4 sm:p-6 prose prose-sm sm:prose-base max-w-none"
                      dangerouslySetInnerHTML={{ __html: content.description }}
                    />
                    {/* {content.description.length > 5 && (
                        <Link to="#" className="block text-blue-500 hover:text-blue-700 p-5"> Read More</Link>
                      )} */}
                  </div>
                </div>
              </div>
            </section>

            {/* <Ads /> */}
            {/* <Subscribe /> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default BlogDetails;
